/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvestigationError } from './InvestigationError';
import {
    InvestigationErrorFromJSON,
    InvestigationErrorFromJSONTyped,
    InvestigationErrorToJSON,
} from './InvestigationError';

/**
 * State and some parameters of Bronze id credentials workflow
 * @export
 * @interface BronzeIdStatusResponseDto
 */
export interface BronzeIdStatusResponseDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof BronzeIdStatusResponseDto
     */
    workflowInstanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof BronzeIdStatusResponseDto
     */
    bronzeIdState?: BronzeIdStatusResponseDtoBronzeIdStateEnum;
    /**
     * Org lei
     * @type {string}
     * @memberof BronzeIdStatusResponseDto
     */
    lei?: string;
    /**
     * How user proofs that they have access to the domain
     * @type {string}
     * @memberof BronzeIdStatusResponseDto
     */
    dnsCheckMode?: BronzeIdStatusResponseDtoDnsCheckModeEnum;
    /**
     * Expected text in DNS records, present only if dnsCheckMode is TEXT_RECORD
     * @type {string}
     * @memberof BronzeIdStatusResponseDto
     */
    dnsExpectedText?: string;
    /**
     * 
     * @type {string}
     * @memberof BronzeIdStatusResponseDto
     */
    workflowModelId?: string;
    /**
     * 
     * @type {string}
     * @memberof BronzeIdStatusResponseDto
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof BronzeIdStatusResponseDto
     */
    legalCompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof BronzeIdStatusResponseDto
     */
    headquartersAddress?: string;
    /**
     * 
     * @type {Array<InvestigationError>}
     * @memberof BronzeIdStatusResponseDto
     */
    errors?: Array<InvestigationError>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BronzeIdStatusResponseDto
     */
    rejectionReason?: Array<string>;
}


/**
 * @export
 */
export const BronzeIdStatusResponseDtoBronzeIdStateEnum = {
    Started: 'STARTED',
    PartiallyConfigured: 'PARTIALLY_CONFIGURED',
    DomainInvestigation: 'DOMAIN_INVESTIGATION',
    OperatorConfirmation: 'OPERATOR_CONFIRMATION',
    Issuing: 'ISSUING',
    RequiresRetry: 'REQUIRES_RETRY',
    FailedToVet: 'FAILED_TO_VET',
    VettedSuccessfully: 'VETTED_SUCCESSFULLY'
} as const;
export type BronzeIdStatusResponseDtoBronzeIdStateEnum = typeof BronzeIdStatusResponseDtoBronzeIdStateEnum[keyof typeof BronzeIdStatusResponseDtoBronzeIdStateEnum];

/**
 * @export
 */
export const BronzeIdStatusResponseDtoDnsCheckModeEnum = {
    TextRecord: 'TEXT_RECORD',
    UploadedFile: 'UPLOADED_FILE'
} as const;
export type BronzeIdStatusResponseDtoDnsCheckModeEnum = typeof BronzeIdStatusResponseDtoDnsCheckModeEnum[keyof typeof BronzeIdStatusResponseDtoDnsCheckModeEnum];


/**
 * Check if a given object implements the BronzeIdStatusResponseDto interface.
 */
export function instanceOfBronzeIdStatusResponseDto(value: object): boolean {
    return true;
}

export function BronzeIdStatusResponseDtoFromJSON(json: any): BronzeIdStatusResponseDto {
    return BronzeIdStatusResponseDtoFromJSONTyped(json, false);
}

export function BronzeIdStatusResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BronzeIdStatusResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'] == null ? undefined : json['workflowInstanceId'],
        'bronzeIdState': json['bronzeIdState'] == null ? undefined : json['bronzeIdState'],
        'lei': json['lei'] == null ? undefined : json['lei'],
        'dnsCheckMode': json['dnsCheckMode'] == null ? undefined : json['dnsCheckMode'],
        'dnsExpectedText': json['dnsExpectedText'] == null ? undefined : json['dnsExpectedText'],
        'workflowModelId': json['workflowModelId'] == null ? undefined : json['workflowModelId'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'legalCompanyName': json['legalCompanyName'] == null ? undefined : json['legalCompanyName'],
        'headquartersAddress': json['headquartersAddress'] == null ? undefined : json['headquartersAddress'],
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(InvestigationErrorFromJSON)),
        'rejectionReason': json['rejectionReason'] == null ? undefined : json['rejectionReason'],
    };
}

export function BronzeIdStatusResponseDtoToJSON(value?: BronzeIdStatusResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'bronzeIdState': value['bronzeIdState'],
        'lei': value['lei'],
        'dnsCheckMode': value['dnsCheckMode'],
        'dnsExpectedText': value['dnsExpectedText'],
        'workflowModelId': value['workflowModelId'],
        'domain': value['domain'],
        'legalCompanyName': value['legalCompanyName'],
        'headquartersAddress': value['headquartersAddress'],
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(InvestigationErrorToJSON)),
        'rejectionReason': value['rejectionReason'],
    };
}

